import { Action } from 'redux';
import { PlanSummaryListPaginatorStateStructure } from './interfaces/plan-summary-list-paginator.state.interface';

const INITIAL_STATE_STRUCTURE: PlanSummaryListPaginatorStateStructure = {
  pageIndex: 0,
  pageSize: null,
  totalLength: 0
};

/** ACTION CLASS */
export class PlanSummaryListPaginatorAction implements Action {
  type: string;
  pageIndex?: number;
  pageSize?: number;
  totalLength?: number;
}

/** ACTIONS TYPES */
const RESET_CURRENT_PAGE = 'RESET_CURRENT_PAGE';
const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
const SET_TOTAL_LENGTH = 'SET_TOTAL_LENGTH';

/** ACTIONS */
export function resetPageIndex(): PlanSummaryListPaginatorAction {
  return { type: RESET_CURRENT_PAGE };
}
export function setPaginationData(pageIndex: number, pageSize: number): PlanSummaryListPaginatorAction {
  return { type: SET_CURRENT_PAGE, pageIndex, pageSize };
}
export function setTotalLength(totalLength: number): PlanSummaryListPaginatorAction {
  return { type: SET_TOTAL_LENGTH, totalLength };
}
export const PLAN_SUMMARY_LIST_PAGINATOR = 'PlanSummaryListPaginator';
export function PlanSummaryListPaginator(
  state: PlanSummaryListPaginatorStateStructure = INITIAL_STATE_STRUCTURE,
  action: PlanSummaryListPaginatorAction
) {

  const copiedState: PlanSummaryListPaginatorStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case SET_CURRENT_PAGE:
      copiedState.pageIndex = action.pageIndex;
      copiedState.pageSize = action.pageSize;
      return Object.assign({}, state, copiedState);

    case RESET_CURRENT_PAGE:
      return Object.assign({}, state, INITIAL_STATE_STRUCTURE);

    case SET_TOTAL_LENGTH:
      copiedState.totalLength = action.totalLength || 0;
      return Object.assign({}, state, copiedState);

    default:
      return state;

  }
}
